module.exports = __webpack_public_path__ + "img/vasarlas.76a02bf0.jpg";